import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypePngIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#AE74B9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#7E3E8A"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.29627 12.57C7.2134 12.6668 7.19452 12.803 7.24782 12.9187C7.30104 13.0345 7.41681 13.1085 7.54427 13.1085H8.97996L10.6809 11.1206L9.89322 10.1999C9.82212 10.1168 9.71812 10.069 9.60863 10.069C9.49924 10.069 9.39524 10.1168 9.32405 10.1999C9.32405 10.1999 8.01564 11.7293 7.29627 12.57ZM9.96585 13.1085H16.8004C16.9277 13.1085 17.0435 13.0345 17.0968 12.9187C17.1501 12.803 17.1312 12.6668 17.0484 12.57C16.1009 11.4627 14.022 9.03302 14.022 9.03302C13.9508 8.94987 13.8469 8.90196 13.7374 8.90196C13.628 8.90196 13.524 8.94987 13.4529 9.03302L9.96585 13.1085ZM8.61421 5.61792C7.58068 5.61792 6.74158 6.45702 6.74158 7.49055C6.74158 8.52417 7.58068 9.36327 8.61421 9.36327C9.64782 9.36327 10.4869 8.52417 10.4869 7.49055C10.4869 6.45702 9.64782 5.61792 8.61421 5.61792Z"
      fill="#AE74B9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.339 15.7303H16.338C15.0975 15.7303 14.0918 16.7359 14.0918 17.9766V17.9775C14.0918 19.2186 15.0979 20.2247 16.339 20.2247C17.0547 20.2247 17.709 19.8204 18.0291 19.1802C18.0564 19.1254 18.0779 19.0825 18.0779 19.0825C18.1036 19.0318 18.118 18.9745 18.118 18.9138V18.2115C18.118 18.0047 17.9503 17.837 17.7435 17.8371H16.339C16.1322 17.837 15.9644 18.0049 15.9644 18.2115C15.9644 18.4183 16.1322 18.5861 16.339 18.5861H17.3689V18.8254L17.359 18.8452C17.1659 19.2316 16.771 19.4756 16.339 19.4756C15.5116 19.4756 14.8408 18.8049 14.8408 17.9775V17.9766C14.8408 17.1496 15.5111 16.4793 16.338 16.4793H16.339C16.5589 16.4793 16.7691 16.5426 16.948 16.6556C17.0634 16.7285 17.1658 16.8221 17.2494 16.9328C17.3739 17.0978 17.6089 17.1307 17.7739 17.0062C17.9389 16.8817 17.9718 16.6467 17.8473 16.4817C17.7089 16.2982 17.5393 16.143 17.348 16.0222C17.0515 15.835 16.7032 15.7303 16.339 15.7303Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M6.60118 18.5861H8.23578C8.88432 18.5861 9.41007 18.0604 9.41007 17.4118V16.9046C9.41007 16.256 8.88432 15.7303 8.23578 15.7303C7.40549 15.7303 6.22661 15.7303 6.22661 15.7303C6.01978 15.7303 5.85205 15.8979 5.85205 16.1048V19.8501C5.85205 20.0568 6.01987 20.2247 6.22661 20.2247C6.43326 20.2247 6.60109 20.0568 6.60118 19.8501V18.5861ZM6.60118 17.837H8.23587C8.47066 17.837 8.66104 17.6467 8.66104 17.4118V16.9046C8.66104 16.6697 8.47066 16.4793 8.23578 16.4793H6.60118V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.721 19.8501V17.2591L12.857 20.0764C12.9541 20.2046 13.1223 20.2564 13.2748 20.2052C13.4272 20.1538 13.5299 20.011 13.5299 19.8501V16.1048C13.5299 15.8981 13.3621 15.7303 13.1554 15.7303C12.9487 15.7303 12.7808 15.8981 12.7808 16.1048V18.7362L10.6448 15.919C10.5477 15.7908 10.3795 15.7389 10.227 15.7902C10.0746 15.8415 9.97183 15.9844 9.97192 16.1452V19.8501C9.97183 20.0568 10.1397 20.2247 10.3464 20.2247C10.5531 20.2247 10.721 20.0568 10.721 19.8501Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypePngIcon;
